import { isAPIException } from '~~/types/APIException'

export default async function handleAsync<T>(asyncFunction: (...params: unknown[]) => Promise<T>, errorMessage?: string): Promise<void> {
	const { error, loading } = useApp()
	loading.value = true
	try {
		await asyncFunction()
	} catch (err: unknown) {
		// Determine user-friendly error message
		if (isAPIException(err) && err.detail) {
			error.value = err.detail
		} else {
			error.value = errorMessage || 'Ein unerwarteter Fehler ist aufgetreten'
		}

		// Error will be automatically captured by app:error hook
		throw createError({
			statusCode: 500,
			statusMessage: errorMessage,
			cause: err,
		})
	} finally {
		loading.value = false
	}
}
